import { useJsApiLoader } from "@react-google-maps/api";
import Map from "./components/Map";
import { mapOptions } from "./components/MapConfiguration";
import Navbar from "./navbar";
import { useState } from "react";
import "./mapshow.css";
import Sidebar from "./Sidebar";

function Mapshow() {
  const { isLoaded } = useJsApiLoader({
    id: mapOptions.googleMapApiKey,
    googleMapsApiKey: mapOptions.googleMapApiKey,
  });
  const [query, setQuery] = useState('');


  return (
    <div className="mapshow">
      <div className="mapshow-inner">
        <Map isLoaded={isLoaded} />
      </div>
    </div>
  );
}

export default Mapshow;